import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import Gallery from './Gallery';
import { showcaseData } from '@/assets/showcase';

export default function Showcase() {
  const { t } = useTranslation();

  const handleViewCollection = () => {
    window.open('https://magiceden.io/ordinals/marketplace/noderocks', '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="relative bg-dark py-12 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,_theme(colors.primary/0.3)_0%,_transparent_70%)]"></div>
        <div className="absolute inset-0 bg-[conic-gradient(from_0deg_at_50%_50%,theme(colors.primary/0.1),theme(colors.primary-light/0.1),theme(colors.primary/0.1))]"></div>
        
        <div className="absolute inset-0 opacity-20">
          <div className="absolute inset-0 bg-[linear-gradient(45deg,theme(colors.primary/0.5)_1px,transparent_1px),linear-gradient(-45deg,theme(colors.primary-light/0.5)_1px,transparent_1px)]"
               style={{ backgroundSize: '30px 30px', transform: 'perspective(1000px) rotateX(60deg)' }}></div>
        </div>

        {[...Array(30)].map((_, i) => (
          <div
            key={i}
            className="absolute rounded-full animate-twinkle mix-blend-screen"
            style={{
              width: `${Math.random() * 4 + 2}px`,
              height: `${Math.random() * 4 + 2}px`,
              background: `hsl(${Math.random() * 360}deg 100% 70%)`,
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              filter: 'blur(1px)',
              boxShadow: '0 0 10px currentColor'
            }}
          />
        ))}
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-16 relative">
          <h2 className="text-4xl md:text-7xl font-bold mb-4 md:mb-6 relative">
            <span className="absolute inset-0 text-primary opacity-50 animate-pulse blur-sm">
              {t('showcase.title')}
            </span>
            <span className="relative text-transparent bg-clip-text bg-gradient-to-r 
              from-primary via-primary-light to-primary animate-gradient-x">
              {t('showcase.title')}
            </span>
          </h2>
          <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto">
            {t('showcase.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8">
          {showcaseData.map((data, index) => (
            <div key={index} className="group relative">
              <div className="absolute -inset-0.5 bg-gradient-to-r from-primary to-primary-light 
                rounded-xl blur opacity-25 group-hover:opacity-50 transition duration-500"></div>
              <div className="relative card overflow-hidden backdrop-blur-sm
                bg-gradient-to-br from-dark-lighter/80 to-dark/80">
                <Gallery 
                  images={data.images}
                  interval={data.interval}
                />
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8 md:mt-16">
          <button 
            onClick={handleViewCollection}
            className="group relative inline-flex items-center gap-2 px-6 md:px-8 py-2 md:py-3 
              rounded-lg overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-primary to-primary-light 
              opacity-50 group-hover:opacity-70 transition-opacity duration-300"></div>
            <div className="absolute inset-0 bg-gradient-to-r from-primary to-primary-light 
              opacity-0 group-hover:opacity-20 animate-pulse"></div>
            <span className="relative text-white font-semibold">
              {t('showcase.viewCollection')}
              <ArrowRight className="inline-block w-4 md:w-5 h-4 md:h-5 ml-2 group-hover:translate-x-1 transition-transform" />
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}